module.exports = __webpack_public_path__ + "img/dcr.858b5ebf.svg";